import { router } from "@inertiajs/react";
import { MoreHorizontal } from "lucide-react";
import { Button } from "@/components/ui/Button";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator,
} from "@/components/ui/DropdownMenu";
import { claim_task_path, close_task_path, snooze_task_path, task_path } from "@/lib/routes";
import type { Task } from "@/pages/Tasks/task";

// The row's overflow menu: Remind me later · Assign to me · Delete. Entries
// appear only when the server says the viewer can perform them — Delete is
// Super Admin only. (Details open by clicking the row itself.)
export default function TaskRowMenu({ task, onPause }: {
  task: Task;
  onPause: () => void;
}) {
  const post = (path: string) => router.post(path, {}, { preserveScroll: true });
  const del = (path: string) => router.delete(path, { preserveScroll: true });

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          aria-label="More actions"
          onClick={(e) => e.stopPropagation()}
          className="h-7 w-7 text-muted-foreground opacity-40 transition-opacity focus-visible:opacity-100 focus-visible:ring-2 focus-visible:ring-ring group-hover:opacity-100"
        >
          <MoreHorizontal size={16} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" onClick={(e) => e.stopPropagation()}>
        {task.can.claim && (
          <DropdownMenuItem onSelect={() => post(claim_task_path(task.id))}>Assign to me</DropdownMenuItem>
        )}

        {task.can.snooze && <DropdownMenuItem onSelect={onPause}>Remind me later</DropdownMenuItem>}
        {task.can.resume && (
          <DropdownMenuItem onSelect={() => del(snooze_task_path(task.id))}>Resume reminders</DropdownMenuItem>
        )}
        {task.can.close && (
          <DropdownMenuItem onSelect={() => post(close_task_path(task.id))}>Close task</DropdownMenuItem>
        )}
        {task.can.delete && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              className="text-destructive focus:text-destructive"
              onSelect={() => {
                if (window.confirm(`Delete "${task.details}"? This can't be undone.`)) del(task_path(task.id));
              }}
            >
              Delete task
            </DropdownMenuItem>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
